"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _config = require("./config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaLoadingIndicator = _react["default"].forwardRef(function (props, ref) {
  var depCheck = function depCheck(props) {};

  depCheck(props);
  var className = props.className,
      size = props.size,
      type = props.type,
      other = props.other;

  var getClassList = function getClassList() {
    var _classnames;

    var base = _config.classes.base,
        types = _config.classes.types,
        sizes = _config.classes.sizes;
    return (0, _classnames2["default"])((_classnames = {}, _defineProperty(_classnames, base, true), _defineProperty(_classnames, types.inline, type === _config.LunaLoadingIndicatorTypes.inline), _defineProperty(_classnames, sizes.size5, size === _config.LunaLoadingIndicatorSizes.size5), _defineProperty(_classnames, sizes.size10, !size || size === _config.LunaLoadingIndicatorSizes.size10), _defineProperty(_classnames, sizes.size20, size === _config.LunaLoadingIndicatorSizes.size20), _defineProperty(_classnames, sizes.size30, size === _config.LunaLoadingIndicatorSizes.size30), _classnames), className);
  };

  return _react["default"].createElement("div", _extends({}, other, {
    className: getClassList(),
    ref: ref
  }), _react["default"].createElement("svg", {
    className: "luna-loading-spinner",
    viewBox: "0 0 120 120",
    preserveAspectRatio: "xMidYMid meet"
  }, _react["default"].createElement("circle", {
    className: "luna-loading-path",
    cx: "60",
    cy: "60",
    r: "50"
  })));
});

LunaLoadingIndicator.displayName = 'LunaLoadingIndicator';
LunaLoadingIndicator.ENUMS = _config.ENUMS;
LunaLoadingIndicator.propTypes = {
  className: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(Object.values(_config.LunaLoadingIndicatorSizes)),
  type: _propTypes["default"].oneOf(Object.values(_config.LunaLoadingIndicatorTypes)),
  other: _propTypes["default"].object
};
LunaLoadingIndicator.defaultProps = {
  other: {}
};
var _default = LunaLoadingIndicator;
exports["default"] = _default;
